import React, { useEffect } from 'react';
import { Box, Container, Typography, Card, CardContent, Grid, Chip, Stack, Button } from '@mui/material';
import { Check, Construction } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const FacturationBtp = () => {
  const navigate = useNavigate();

  const goToRegisterTracked = () => {
    const params = new URLSearchParams({
      utm_source: 'site_facteio',
      utm_medium: 'cta',
      utm_campaign: 'facturation_btp',
      utm_content: 'cta_page'
    });
    navigate(`/register?${params.toString()}`);
  };

  useEffect(() => {
    document.title = 'Logiciel devis facture BTP | Facteio';
    const description = 'Logiciel de facturation BTP: devis chantier, lignes main d’œuvre/fournitures, acomptes avancés et mentions spécifiques.';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
  }, []);

  return (
    <Box sx={(theme) => ({ background: theme.palette.background.default, minHeight: '100vh', py: 5 })}>
      <Container maxWidth="lg">
        <Button variant="text" onClick={() => navigate('/')} sx={{ mb: 2, fontWeight: 600 }}>← Retour à l'accueil</Button>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" mb={2}>
          <Chip icon={<Construction />} label="Facturation BTP" sx={{ bgcolor: '#E5E8EE', color: '#1F2937' }} />
          <Chip icon={<Check />} label="Discours adapté chantier" />
          <Chip icon={<Check />} label="SEO + Ads ciblées" />
        </Stack>

        <Typography variant="h3" fontWeight={800} mb={1}>Devis et factures BTP, pensés terrain</Typography>
        <Typography variant="h6" color="text.secondary" mb={4}>
          Gagnez du temps sur vos documents chantier avec un cadre clair: acomptes, fournitures, main d’œuvre et conformité.
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card><CardContent>
              <Typography variant="h6" fontWeight={700} mb={2}>Fonctionnalités ciblées BTP</Typography>
              <Typography>• Modèles devis avec lignes “Main d’œuvre” et “Fournitures”</Typography>
              <Typography>• Gestion acomptes avancée</Typography>
              <Typography>• Mentions spécifiques chantier</Typography>
            </CardContent></Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card><CardContent>
              <Typography variant="h6" fontWeight={700} mb={2}>Pourquoi cette page performe</Typography>
              <Typography>• Message orienté artisan/PME BTP</Typography>
              <Typography>• Mots-clés longue traîne “facturation btp”</Typography>
              <Typography>• Appel à l’action adapté au besoin métier</Typography>
            </CardContent></Card>
          </Grid>
        </Grid>

        <Card sx={{ mt: 4, border: '1px solid #D5CDC3' }}>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h5" fontWeight={800} mb={1}>
              Passez moins de temps sur l’admin chantier
            </Typography>
            <Typography color="text.secondary" mb={2}>
              Sans changer vos habitudes terrain: vos devis/factures restent simples, mais beaucoup plus cadrés.
            </Typography>
            <Button
              variant="contained"
              sx={{ background: 'linear-gradient(135deg, #1F2937 0%, #4B5563 100%)' }}
              onClick={goToRegisterTracked}
            >
              Essayer Facteio pour le BTP
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default FacturationBtp;
